import { Flag } from 'components/Basic/Flag/Flag';
import { SimpleFlagType } from 'types/flag';
import { ProductDetailType } from 'types/product';

type ProductFlagsProps = {
    isProductDetail: boolean;
    flags: SimpleFlagType[];
    product: ProductDetailType;
};

const testIdentifier = 'blocks-product-detail-flags-';

const ProductDetailFlags: FC<ProductFlagsProps> = (props) => {
    if (props.flags.length === 0) {
        return null;
    }

    return (
        <ul className="absolute right-0 top-0 flex flex-col gap-1">
            {props.flags.map((flag, key) =>
                flag.visible ? (
                    <Flag
                        className="pointer-events-none mb-2.5 h-[40px] cursor-default self-end py-0 px-4 text-tiny font-bold"
                        backgroundColor={flag.rgbColor}
                        data-testid={testIdentifier + key}
                        fixedWidth={flag.isActionFlag}
                        flagLink={flag.slug}
                        key={flag.slug}
                        large
                    >
                        {flag.isActionFlag && props.product.isInAction
                            ? `-${props.product.actionDiscountPercent} %`
                            : flag.name}
                    </Flag>
                ) : null,
            )}
        </ul>
    );
};

export default ProductDetailFlags;
